import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-row items-center gap-2" }

import EntriesListTitleInfoDialog from '@/components/entries/dialogs/EntriesListTitleInfoDialog.vue'
import InfoIcon from '@/components/icons/InfoIcon.vue'
import { useDialog } from '@/core/composables/useDialog'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useStore } from 'vuex'

type EntryModule = 'incomes' | 'expenses' | 'bank-transactions'

interface Props {
  /** The entry module type */
  entryModule: EntryModule
  /** HTML tag to use for the title */
  tag?: string
}


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'EntriesListTitle'
},
  __name: 'EntriesListTitle',
  props: {
    entryModule: {},
    tag: { default: 'h2' }
  },
  setup(__props: any) {





const store = useStore()
const isTlpService = computed<boolean>(() => store.getters['app/isTlpService'])

const { t } = useI18n()
const { showDialog } = useDialog()

const openInfoDialog = (): void => {
  showDialog({
    component: EntriesListTitleInfoDialog,
    props: {
      entryModule: __props.entryModule
    }
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(__props.tag), { class: "heading-2" }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(isTlpService.value && __props.entryModule === 'incomes'
          ? _unref(t)(`routes.invoices`)
          : _unref(t)(`routes.${__props.entryModule}`)), 1)
      ]),
      _: 1
    })),
    _createVNode(InfoIcon, {
      class: "text-primary",
      onClick: openInfoDialog
    })
  ]))
}
}

})